export const FETCH_VOLUME_PERFORMANCE_REPORT =
  'FETCH_VOLUME_PERFORMANCE_REPORT';
export const FETCH_AUTH_TOKEN = 'FETCH_AUTH_TOKEN';
export const FETCH_REFRESH_TOKEN = 'FETCH_REFRESH_TOKEN';
export const FETCH_LOGOUT = 'FETCH_LOGOUT';
export const FETCH_RESET_PASSWORD = 'FETCH_RESET_PASSWORD';
export const FETCH_MULE_TOKEN = 'FETCH_MULE_TOKEN';
export const FETCH_ABACUS_CONVERSATION_RESP = 'FETCH_ABACUS_CONVERSATION_RESP';

export const FETCH_TGENV_VOLUME = 'FETCH_TGENV_VOLUME';

export const FETCH_CLIENTS_DASHBOARD = 'FETCH_CLIENTS_DASHBOARD';
export const FETCH_TEAMS_DASHBOARD = 'FETCH_TEAMS_DASHBOARD';
export const FETCH_HOME_DASHBOARD = 'FETCH_HOME_DASHBOARD';
export const FETCH_INCENTIVE_TRIP_BONUS_DASHBOARD =
  'FETCH_INCENTIVE_TRIP_BONUS_DASHBOARD';

export const FETCH_BONUS_BANNER = 'FETCH_BONUS_BANNER';
export const FETCH_COACH_RANK_PROGRESSION = 'FETCH_COACH_RANK_PROGRESSION';
export const FETCH_COACH_PERFORMANCE = 'FETCH_COACH_PERFORMANCE';
export const FETCH_COACH_TEAMS = 'FETCH_COACH_TEAMS';
export const FETCH_CLIENT = 'FETCH_CLIENT';
export const FETCH_CANDIDATE = 'FETCH_CANDIDATE';
export const FETCH_MY_TEAMS_VIEW_TEAMS = 'FETCH_MY_TEAMS_VIEW_TEAMS';
export const WATCHLIST = 'ADD_WATCHLIST';
export const FETCH_WATCHLIST = 'FETCH_WATCHLIST';
export const FETCH_MERGECANDIDATE = 'FETCH_MERGECANDIDATE';
export const DELETE_CANDIDATE = 'DELETE_CANDIDATE';
export const FETCH_CANDIDATE_DECLINE_REASONS =
  'FETCH_CANDIDATE_DECLINE_REASONS';
export const FETCH_CANDIDATE_DISPOSITION_OPTIONS =
  'FETCH_CANDIDATE_DISPOSITION_OPTIONS';
export const FETCH_CLIENT_ORDERS = 'FETCH_CLIENT_ORDERS';
export const FETCH_CLIENT_ORDER = 'FETCH_CLIENT_ORDER';
export const FETCH_COACH = 'FETCH_COACH';

export const SEARCH_COACH = 'SEARCH_COACH';
export const CLIENT_TO_CONTACT = 'CLIENT_TO_CONTACT';

export const CLIENT_JOURNEY_ALL_TASKS = 'CLIENT_JOURNEY_ALL_TASKS';
export const CLIENT_JOURNEY_TASKS = 'CLIENT_JOURNEY_TASKS';

export const CANDIDATE_INFO = 'CANDIDATE_INFO';
export const CANDIDATES = 'CANDIDATES';
export const FETCH_SAME_DAY_LAST_MONTH = 'FETCH_SAME_DAY_LAST_MONTH';
export const BASE_ENDPOINT = 'BASE_ENDPOINT';
export const FETCH_BONUSES = 'FETCH_BONUSES';
export const FETCH_CLIENTS_ALERTS = 'FETCH_CLIENTS_ALERTS';
export const DISMISS_CLIENTS_ALERTS = 'DISMISS_CLIENTS_ALERTS';
export const FETCH_MULE_AUTH_TOKEN = 'FETCH_MULE_AUTH_TOKEN';
export const FETCH_MULE_REVOKE_TOKEN = 'FETCH_MULE_REVOKE_TOKEN';
export const FETCH_SFMC_CONTACT_KEY = 'FETCH_SFMC_CONTACT_KEY';

export const FETCH_MWL_HEALTH_ROOT_PROFILE = 'FETCH_MWL_HEALTH_ROOT_PROFILE';
export const FETCH_MSWL_HEALTH_ROOT_PROFILE = 'FETCH_MSWL_HEALTH_ROOT_PROFILE';
export const FETCH_CLIENT_WEIGHT_GRAPH_DETAILS =
  'FETCH_CLIENT_WEIGHT_GRAPH_DETAILS';
export const FETCH_CLIENT_BODY_MEASUREMENTS = 'FETCH_CLIENT_BODY_MEASUREMENTS';
export const FETCH_CLIENT_START_DATE = 'FETCH_CLIENT_START_DATE';
export const FETCH_CLIENT_MEAL_PLAN = 'FETCH_CLIENT_MEAL_PLAN';
export const FETCH_COACH_SHARE_PLAN = 'FETCH_COACH_SHARE_PLAN';
export const FETCH_CLIENT_MY_WHY = 'FETCH_CLIENT_MY_WHY';

export const POST_CANDIDATE_REMINDER = 'POST_CANDIDATE_REMINDER';
export const DELETE_CANDIDATE_REMINDER = 'DELETE_CANDIDATE_REMINDER';
export const UPDATE_CANDIDATE_REMINDER = 'UPDATE_CANDIDATE_REMINDER';

export const FETCH_EDGE_365_CHALLENGE_TASKS = 'FETCH_EDGE_365_CHALLENGE_TASKS';
export const UPDATE_EDGE_365_CHALLENGE_TASKS =
  'UPDATE_EDGE_365_CHALLENGE_TASKS';

export const FETCH_BUSINESS_PROFILE = 'FETCH_BUSINESS_PROFILE';
export const PATCH_BUSINESS_PROFILE = 'PATCH_BUSINESS_PROFILE';
export const SET_BUSINESS_PROFILE_LOADING = 'SET_BUSINESS_PROFILE_LOADING';
export const SET_BUSINESS_PROFILE_SAVING = 'SET_BUSINESS_PROFILE_SAVING';
export const SET_BUSINESS_PROFILE_ERROR = 'SET_BUSINESS_PROFILE_ERROR';
export const RESET_BUSINESS_PROFILE = 'RESET_BUSINESS_PROFILE';

export const FETCH_SOCIAL_MEDIA = 'FETCH_SOCIAL_MEDIA';
export const PATCH_SOCIAL_MEDIA = 'PATCH_SOCIAL_MEDIA';
export const SET_SOCIAL_MEDIA_LOADING = 'SET_SOCIAL_MEDIA_LOADING';
export const SET_SOCIAL_MEDIA_SAVING = 'SET_SOCIAL_MEDIA_SAVING';
export const SET_SOCIAL_MEDIA_ERROR = 'SET_SOCIAL_MEDIA_ERROR';

export const FETCH_LEADS_POOL = 'FETCH_LEADS_POOL';
export const PATCH_LEADS_POOL = 'PATCH_LEADS_POOL';
export const SET_LEADS_POOL_LOADING = 'SET_LEADS_POOL_LOADING';
export const SET_LEADS_POOL_SAVING = 'SET_LEADS_POOL_SAVING';
export const SET_LEADS_POOL_ERROR = 'SET_LEADS_POOL_ERROR';

export const FETCH_HEALTH_CARE_DATA = 'FETCH_HEALTH_CARE_DATA';
export const PUT_HEALTH_CARE_DATA = 'PUT_HEALTH_CARE_DATA';
export const SET_HEALTH_CARE_LOADING = 'SET_HEALTH_CARE_LOADING';
export const SET_HEALTH_CARE_SAVING = 'SET_HEALTH_CARE_SAVING';
export const SET_HEALTH_CARE_ERROR = 'SET_HEALTH_CARE_ERROR';

export const FETCH_SUPPORTED_LANGUAGES = 'FETCH_SUPPORTED_LANGUAGES';
export const PUT_SUPPORTED_LANGUAGES = 'PUT_SUPPORTED_LANGUAGES';
export const SET_SUPPORTED_LANGUAGES_LOADING =
  'SET_SUPPORTED_LANGUAGES_LOADING';
export const SET_SUPPORTED_LANGUAGES_SAVING = 'SET_SUPPORTED_LANGUAGES_SAVING';
export const SET_SUPPORTED_LANGUAGES_ERROR = 'SET_SUPPORTED_LANGUAGES_ERROR';

export const POST_COACH_IMAGE = 'POST_COACH_IMAGE';
export const SET_BUSINESS_PROFILE_IMAGE = ' SET_BUSINESS_PROFILE_IMAGE';
export const SET_BUSINESS_PROFILE_IMAGE_SAVING =
  'SET_BUSINESS_PROFILE_IMAGE_SAVING';
export const SET_BUSINESS_PROFILE_IMAGE_ERROR =
  'SET_BUSINESS_PROFILE_IMAGE_ERROR';

// Request methods
export const REQUEST_GET = 'GET';
export const REQUEST_POST = 'POST';
export const REQUEST_PUT = 'PUT';
export const REQUEST_PATCH = 'PATCH';
